document.documentElement.classList.remove('no-js');

const header = document.querySelector('[data-site-header]');
const backHomeButton = document.querySelector('[data-back-home]');

if (header) {
  const updateHeader = () => {
    header.classList.toggle('is-scrolled', window.scrollY > 8);
    if (backHomeButton) backHomeButton.classList.toggle('is-visible', window.scrollY > 720);
  };

  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
} else if (backHomeButton) {
  const updateBackHome = () => {
    backHomeButton.classList.toggle('is-visible', window.scrollY > 720);
  };

  updateBackHome();
  window.addEventListener('scroll', updateBackHome, { passive: true });
}

document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
  button.addEventListener('click', () => {
    const drawer = document.querySelector('[data-mobile-drawer]');
    if (!drawer) return;

    const isHidden = drawer.hasAttribute('hidden');
    drawer.toggleAttribute('hidden', !isHidden);
    button.classList.toggle('is-active', isHidden);
  });
});

const updateCartCount = (count) => {
  const badge = document.querySelector('[data-cart-count]');
  if (!badge) return;

  badge.textContent = count;
  badge.toggleAttribute('hidden', Number(count) === 0);
};

const getVariantImage = (variant) => (
  variant?.featured_image?.src ||
  variant?.featured_media?.preview_image?.src ||
  variant?.image?.src ||
  ''
);

const swapImageSource = (image, src) => {
  if (!image || !src) return;
  image.src = src;
  image.removeAttribute('srcset');

  const media = image.closest('[data-product-media]');
  const zoomSource = media?.querySelector('.product-zoom-image');
  const zoomPaneImage = media?.querySelector('.product-zoom-pane img');
  if (zoomSource) {
    zoomSource.src = src;
    zoomSource.removeAttribute('srcset');
  }
  if (zoomPaneImage) {
    zoomPaneImage.src = src;
    zoomPaneImage.removeAttribute('srcset');
  }
};

const normalizeImageUrl = (src = '') => {
  if (!src) return '';

  try {
    const url = new URL(src, window.location.origin);
    return url.pathname
      .replace(/_(\d+x\d*|x\d+)(?=\.)/i, '')
      .replace(/\/\/+/g, '/')
      .toLowerCase();
  } catch (error) {
    return src
      .split('?')[0]
      .replace(/_(\d+x\d*|x\d+)(?=\.)/i, '')
      .toLowerCase();
  }
};

const showProductMediaForOption = (root, optionValue, variantImageSrc = '') => {
  const mediaItems = Array.from(root.querySelectorAll('[data-product-media]'));
  if (!mediaItems.length) return;

  const normalizedVariantSrc = normalizeImageUrl(variantImageSrc);
  const normalizedOption = String(optionValue || '').trim().toLowerCase();
  let target = null;

  if (normalizedVariantSrc) {
    target = mediaItems.find((media) => (
      normalizeImageUrl(media.dataset.mediaSrc).includes(normalizedVariantSrc) ||
      normalizedVariantSrc.includes(normalizeImageUrl(media.dataset.mediaSrc)) ||
      normalizeImageUrl(media.dataset.mediaZoomSrc).includes(normalizedVariantSrc) ||
      normalizedVariantSrc.includes(normalizeImageUrl(media.dataset.mediaZoomSrc))
    ));
  }

  if (!target && normalizedOption) {
    target = mediaItems.find((media) => (media.dataset.mediaAlt || '').includes(normalizedOption));
  }

  if (!target) target = mediaItems[0];

  const image = target.querySelector('.product-media-image');
  const src = variantImageSrc || target.dataset.mediaSrc;
  if (image && src) swapImageSource(image, src);

  target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
};

document.querySelectorAll('[data-product-media]').forEach((media) => {
  const image = media.querySelector('.product-media-image');
  const zoomImage = media.querySelector('.product-zoom-image');
  if (!image || !zoomImage) return;

  const pane = document.createElement('span');
  pane.className = 'product-zoom-pane';
  pane.setAttribute('aria-hidden', 'true');

  const paneImage = zoomImage.cloneNode();
  paneImage.className = '';
  pane.appendChild(paneImage);
  media.appendChild(pane);

  const updateZoom = (event) => {
    const rect = media.getBoundingClientRect();
    const x = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
    const y = Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height));
    const xPercent = `${(x * 100).toFixed(2)}%`;
    const yPercent = `${(y * 100).toFixed(2)}%`;

    media.style.setProperty('--zoom-x', xPercent);
    media.style.setProperty('--zoom-y', yPercent);
    paneImage.style.transformOrigin = `${xPercent} ${yPercent}`;
  };

  media.addEventListener('mouseenter', (event) => {
    media.classList.add('is-zooming');
    updateZoom(event);
  });

  media.addEventListener('mousemove', updateZoom);

  media.addEventListener('mouseleave', () => {
    media.classList.remove('is-zooming');
  });
});

document.querySelectorAll('[data-quick-add-form]').forEach((form) => {
  const variantInput = form.querySelector('[data-quick-variant-input]');
  const submit = form.querySelector('[data-quick-submit]');
  const message = form.querySelector('[data-quick-message]');
  const variantJson = form.querySelector('[data-quick-product-json]');
  const variants = variantJson ? JSON.parse(variantJson.textContent || '[]') : [];
  const selectedOptions = {};
  const card = form.closest('[data-product-card]');
  const cardImage = card?.querySelector('.primary-image');
  const styleGroups = Array.from(form.querySelectorAll('[data-quick-option-group][data-option-role="style"]'));
  const hasStyleGroup = styleGroups.length > 0;
  const productUrl = submit?.dataset.productUrl || form.dataset.productUrl || card?.querySelector('.product-card-media')?.getAttribute('href') || '';

  const hasSelectedStyle = () => (
    !hasStyleGroup || styleGroups.every((group) => selectedOptions[group.querySelector('[data-quick-option]')?.dataset.optionIndex])
  );

  const syncQuickVariant = () => {
    const optionIndexes = Array.from(new Set(
      Array.from(form.querySelectorAll('[data-quick-option]')).map((button) => button.dataset.optionIndex)
    ));

    if (!submit) return;

    if (optionIndexes.length === 0) {
      submit.disabled = false;
      submit.textContent = 'Choose size';
      return;
    }

    if (!hasSelectedStyle()) {
      if (variantInput) variantInput.value = '';
      submit.disabled = true;
      submit.textContent = 'Choose color';
      if (message) message.textContent = 'Choose color.';
      return;
    }

    const variant = variants.find((item) => optionIndexes.every((index) => !selectedOptions[index] || item.options[Number(index)] === selectedOptions[index]));
    if (variant) {
      if (variantInput) variantInput.value = variant.id;
      submit.disabled = false;
      submit.textContent = 'Choose size';
      if (message) message.textContent = 'Choose size inside product.';
    } else {
      if (variantInput) variantInput.value = '';
      submit.disabled = true;
      submit.textContent = 'Unavailable';
      if (message) message.textContent = 'This combination is not available.';
    }
  };

  form.querySelectorAll('[data-quick-option]').forEach((pill) => {
    pill.addEventListener('click', () => {
      const optionIndex = pill.dataset.optionIndex;
      const group = pill.closest('[data-quick-option-group]');

      form.querySelectorAll(`[data-quick-option][data-option-index="${optionIndex}"]`).forEach((item) => item.classList.remove('is-selected'));
      pill.classList.add('is-selected');
      selectedOptions[optionIndex] = pill.dataset.optionValue;

      if (group?.dataset.optionRole === 'style') {
        const styleVariant = variants.find((item) => item.options[Number(optionIndex)] === selectedOptions[optionIndex]);
        const selectedImage = getVariantImage(styleVariant);
        swapImageSource(cardImage, selectedImage);
        card?.classList.toggle('is-variant-selected', Boolean(selectedImage));
        if (message) message.textContent = 'Choose size inside product.';
      }

      syncQuickVariant();
    });
  });

  syncQuickVariant();

  submit?.addEventListener('click', () => {
    if (submit.type !== 'button' || submit.disabled) return;

    const variantId = variantInput?.value;
    const targetUrl = variantId ? `${productUrl}?variant=${variantId}` : productUrl;
    if (targetUrl) window.location.href = targetUrl;
  });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    const formData = new FormData(form);
    const variantId = formData.get('id');
    if (!variantId) {
      if (message) message.textContent = 'Choose style and size first.';
      return;
    }

    const button = form.querySelector('button[type="submit"]');
    const previousText = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding...';
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.description || errorData.message || 'Unable to add item');
      }

      const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();
      updateCartCount(cart.item_count);

      if (message) message.textContent = 'Added to bag.';
      if (button) button.textContent = 'Added';
      setTimeout(() => {
        if (button) {
          button.disabled = false;
          button.textContent = previousText || 'Quick Add';
        }
        if (message) message.textContent = '';
      }, 1600);
    } catch (error) {
      if (message) message.textContent = error.message || 'Try again.';
      if (button) {
        button.disabled = false;
        button.textContent = previousText || 'Quick Add';
      }
    }
  });
});

document.querySelectorAll('[data-product-root]').forEach((root) => {
  const variantInput = root.querySelector('[data-variant-input]');
  const addButton = root.querySelector('[data-add-to-cart]');
  const message = root.querySelector('[data-variant-message]');
  const variantJson = root.querySelector('[data-product-json]');
  const variants = variantJson ? JSON.parse(variantJson.textContent || '[]') : [];
  const selectedOptions = {};
  const mainImage = root.querySelector('.product-media-image');
  const styleGroups = Array.from(root.querySelectorAll('[data-product-option-group][data-option-role="style"]'));
  const dependentGroups = Array.from(root.querySelectorAll('[data-product-option-group]:not([data-option-role="style"])'));
  const hasStyleGroup = styleGroups.length > 0;

  const hasSelectedStyle = () => (
    !hasStyleGroup || styleGroups.every((group) => selectedOptions[group.querySelector('[data-product-option]')?.dataset.optionIndex])
  );

  const setDependentGroupsVisible = (visible) => {
    dependentGroups.forEach((group) => {
      group.hidden = !visible;
    });
  };

  setDependentGroupsVisible(!hasStyleGroup);

  const syncProductVariant = () => {
    const optionIndexes = Array.from(new Set(
      Array.from(root.querySelectorAll('[data-product-option]')).map((button) => button.dataset.optionIndex)
    ));
    const hasAllOptions = optionIndexes.every((index) => selectedOptions[index]);

    if (!variantInput || optionIndexes.length === 0) return;

    if (!hasSelectedStyle()) {
      variantInput.value = '';
      if (addButton) {
        addButton.disabled = true;
        addButton.textContent = 'Add to Bag';
      }
      if (message) message.textContent = 'Choose a color first.';
      return;
    }

    if (!hasAllOptions) {
      variantInput.value = '';
      if (addButton) {
        addButton.disabled = true;
        addButton.textContent = 'Add to Bag';
      }
      if (message) message.textContent = 'Choose your options to add this drop.';
      return;
    }

    const variant = variants.find((item) => optionIndexes.every((index) => item.options[Number(index)] === selectedOptions[index]));
    if (variant) {
      variantInput.value = variant.id;
      if (addButton) {
        addButton.disabled = false;
        addButton.textContent = 'Add to Bag';
      }
      if (message) message.textContent = `Selected ${Object.values(selectedOptions).join(' / ')}`;
    } else {
      variantInput.value = '';
      if (addButton) {
        addButton.disabled = true;
        addButton.textContent = 'Unavailable';
      }
      if (message) message.textContent = 'This combination is not available.';
    }
  };

  root.querySelectorAll('[data-product-option]').forEach((pill) => {
    pill.addEventListener('click', () => {
      const optionIndex = pill.dataset.optionIndex;
      const group = pill.closest('[data-product-option-group]');

      root.querySelectorAll(`[data-product-option][data-option-index="${optionIndex}"]`).forEach((item) => item.classList.remove('is-selected'));
      pill.classList.add('is-selected');
      selectedOptions[optionIndex] = pill.dataset.optionValue;

      if (group?.dataset.optionRole === 'style') {
        setDependentGroupsVisible(true);
        dependentGroups.forEach((dependentGroup) => {
          const dependentIndex = dependentGroup.querySelector('[data-product-option]')?.dataset.optionIndex;
          if (dependentIndex) {
            delete selectedOptions[dependentIndex];
            dependentGroup.querySelectorAll('[data-product-option]').forEach((item) => item.classList.remove('is-selected'));
          }
        });

        const styleVariant = variants.find((item) => item.options[Number(optionIndex)] === selectedOptions[optionIndex]);
        showProductMediaForOption(root, selectedOptions[optionIndex], getVariantImage(styleVariant));
        if (message) message.textContent = 'Choose size.';
      }

      syncProductVariant();
    });
  });

  syncProductVariant();

  const productForm = root.querySelector('[data-product-form]');
  productForm?.addEventListener('submit', async (event) => {
    event.preventDefault();

    if (!variantInput?.value) {
      if (message) message.textContent = 'Choose your options first.';
      return;
    }

    const formData = new FormData(productForm);
    const previousText = addButton ? addButton.textContent : '';

    if (addButton) {
      addButton.disabled = true;
      addButton.textContent = 'Adding...';
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.description || errorData.message || 'This item is not available right now.');
      }

      const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();
      updateCartCount(cart.item_count);

      if (message) message.textContent = 'Added to bag.';
      if (addButton) addButton.textContent = 'Added';

      window.setTimeout(() => {
        if (addButton) {
          addButton.disabled = false;
          addButton.textContent = previousText || 'Add to Bag';
        }
      }, 1200);
    } catch (error) {
      if (message) message.textContent = error.message || 'This item is not available right now.';
      if (addButton) {
        addButton.disabled = false;
        addButton.textContent = previousText || 'Add to Bag';
      }
    }
  });
});

document.querySelectorAll('[data-tabs]').forEach((tabs) => {
  const buttons = tabs.querySelectorAll('[data-tab-button]');
  const panels = tabs.querySelectorAll('[data-tab-panel]');

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const tab = button.dataset.tabButton;
      buttons.forEach((item) => item.classList.toggle('is-active', item === button));
      panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.tabPanel === tab));
    });
  });
});

const sizeGuideModal = document.querySelector('[data-size-guide-modal]');

document.querySelectorAll('[data-size-guide-open]').forEach((button) => {
  button.addEventListener('click', () => {
    if (!sizeGuideModal) return;
    sizeGuideModal.removeAttribute('hidden');
    document.body.classList.add('modal-open');
  });
});

document.querySelectorAll('[data-size-guide-close]').forEach((button) => {
  button.addEventListener('click', () => {
    if (!sizeGuideModal) return;
    sizeGuideModal.setAttribute('hidden', '');
    document.body.classList.remove('modal-open');
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape' || !sizeGuideModal || sizeGuideModal.hasAttribute('hidden')) return;
  sizeGuideModal.setAttribute('hidden', '');
  document.body.classList.remove('modal-open');
});

document.querySelectorAll('[data-hero-carousel]').forEach((carousel) => {
  const slides = Array.from(carousel.querySelectorAll('[data-hero-slide]'));
  const dots = Array.from(carousel.querySelectorAll('[data-hero-dot]'));
  const previous = carousel.querySelector('[data-hero-prev]');
  const next = carousel.querySelector('[data-hero-next]');
  const autoplay = carousel.dataset.autoplay === 'true';
  const interval = Number(carousel.dataset.interval || 5000);
  let current = 0;
  let timer;

  if (slides.length <= 1) return;

  const showSlide = (index) => {
    current = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('is-active', slideIndex === current);
    });
    dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === current);
    });
  };

  const start = () => {
    if (!autoplay) return;
    window.clearInterval(timer);
    timer = window.setInterval(() => showSlide(current + 1), interval);
  };

  previous?.addEventListener('click', () => {
    showSlide(current - 1);
    start();
  });

  next?.addEventListener('click', () => {
    showSlide(current + 1);
    start();
  });

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      showSlide(Number(dot.dataset.index));
      start();
    });
  });

  carousel.addEventListener('mouseenter', () => window.clearInterval(timer));
  carousel.addEventListener('mouseleave', start);
  start();
});

document.querySelectorAll('[data-cart-form]').forEach((form) => {
  const subtotalNode = form.querySelector('[data-cart-subtotal]');
  const itemsTotalNode = form.querySelector('[data-cart-items-total]');
  const currency = form.dataset.currency || 'INR';
  let debounceTimer;

  const formatMoney = (cents) => {
    const amount = Number(cents || 0) / 100;
    if (currency === 'INR') return `Rs. ${amount.toFixed(2)}`;

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency
      }).format(amount);
    } catch (error) {
      return `${amount.toFixed(2)}`;
    }
  };

  const recalculateLocal = () => {
    let subtotal = 0;
    form.querySelectorAll('[data-cart-line]').forEach((line) => {
      const quantityInput = line.querySelector('[data-cart-quantity]');
      const quantity = Math.max(0, Number(quantityInput?.value || 0));
      const linePrice = Number(line.dataset.linePrice || 0);
      const lineTotal = quantity * linePrice;
      subtotal += lineTotal;

      const lineTotalNode = line.querySelector('[data-line-total]');
      if (lineTotalNode) lineTotalNode.textContent = formatMoney(lineTotal);
    });

    if (itemsTotalNode) itemsTotalNode.textContent = formatMoney(subtotal);
    if (subtotalNode) subtotalNode.textContent = formatMoney(subtotal);
  };

  const setLineMessage = (line, message = '') => {
    const messageNode = line?.querySelector('[data-cart-line-message]');
    if (messageNode) messageNode.textContent = message;
  };

  const setLineQuantity = (line, quantity) => {
    const input = line?.querySelector('[data-cart-quantity]');
    const normalizedQuantity = Math.max(1, Number(quantity || 1));
    if (input) input.value = normalizedQuantity;

    const minus = line?.querySelector('[data-quantity-minus]');
    if (minus) minus.disabled = normalizedQuantity <= 1;
  };

  const getLineRemoveUrl = (line) => line?.dataset.removeUrl || line?.querySelector('.cart-remove-link')?.getAttribute('href') || '';

  const removeCartLine = (line) => {
    const removeUrl = getLineRemoveUrl(line);
    if (removeUrl) window.location.href = removeUrl;
  };

  const syncQuantity = async (line, quantity) => {
    const key = line.dataset.lineKey;
    if (!key) return;

    const previousQuantity = Math.max(1, Number(line.dataset.lastQuantity || line.querySelector('[data-cart-quantity]')?.defaultValue || 1));
    setLineMessage(line);
    line.classList.add('is-updating');

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: key, quantity })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.description || errorData.message || 'Could not update this quantity.');
      }

      const cart = await response.json();
      updateCartCount(cart.item_count);
      if (subtotalNode) subtotalNode.textContent = formatMoney(cart.total_price);
      if (itemsTotalNode) itemsTotalNode.textContent = formatMoney(cart.original_total_price || cart.items_subtotal_price || cart.total_price);

      if (quantity === 0) {
        line.remove();
        if (cart.item_count === 0) window.location.reload();
      } else {
        const updatedItem = cart.items.find((item) => item.key === key);
        const lineTotalNode = line.querySelector('[data-line-total]');
        if (updatedItem) {
          setLineQuantity(line, updatedItem.quantity);
          line.dataset.lastQuantity = updatedItem.quantity;

          if (lineTotalNode) {
            lineTotalNode.textContent = formatMoney(updatedItem.final_line_price);
          }

          if (updatedItem.quantity < quantity) {
            setLineMessage(line, `Only ${updatedItem.quantity} available for this item.`);
          }
        }
      }
    } catch (error) {
      const errorMessage = error.message || 'Could not update quantity. Please try again.';
      const isSoldOutDecrease = quantity < previousQuantity && /sold out|not available|inventory/i.test(errorMessage);

      if (isSoldOutDecrease) {
        removeCartLine(line);
        return;
      }

      setLineQuantity(line, previousQuantity);
      recalculateLocal();
      setLineMessage(line, errorMessage);
    } finally {
      line.classList.remove('is-updating');
    }
  };

  form.querySelectorAll('[data-cart-quantity]').forEach((input) => {
    const updateMinusState = () => {
      const line = input.closest('[data-cart-line]');
      const minus = line?.querySelector('[data-quantity-minus]');
      if (minus) minus.disabled = Number(input.value || 1) <= 1;
    };

    updateMinusState();
    input.closest('[data-cart-line]')?.setAttribute('data-last-quantity', Math.max(1, Number(input.value || 1)));

    input.addEventListener('input', () => {
      if (Number(input.value || 1) < 1) input.value = 1;
      setLineMessage(input.closest('[data-cart-line]'));
      updateMinusState();
      recalculateLocal();
      const line = input.closest('[data-cart-line]');
      const quantity = Math.max(1, Number(input.value || 1));

      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(() => syncQuantity(line, quantity), 450);
    });

    input.addEventListener('change', () => {
      if (Number(input.value || 1) < 1) input.value = 1;
      setLineMessage(input.closest('[data-cart-line]'));
      updateMinusState();
      recalculateLocal();
      const line = input.closest('[data-cart-line]');
      const quantity = Math.max(1, Number(input.value || 1));
      window.clearTimeout(debounceTimer);
      syncQuantity(line, quantity);
    });
  });

  form.querySelectorAll('[data-quantity-minus], [data-quantity-plus]').forEach((button) => {
    button.addEventListener('click', () => {
      const line = button.closest('[data-cart-line]');
      const input = line?.querySelector('[data-cart-quantity]');
      if (!line || !input) return;

      const current = Math.max(1, Number(input.value || 1));
      const next = button.hasAttribute('data-quantity-plus') ? current + 1 : Math.max(1, current - 1);
      input.value = next;
      setLineMessage(line);
      const minus = line.querySelector('[data-quantity-minus]');
      if (minus) minus.disabled = next <= 1;
      recalculateLocal();

      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(() => syncQuantity(line, next), 250);
    });
  });

  const discountInput = form.querySelector('[data-discount-input]');
  const discountButton = form.querySelector('[data-discount-apply]');
  const discountMessage = form.querySelector('[data-discount-message]');
  const discountClearButton = form.querySelector('[data-discount-remove]');
  const discountRow = form.querySelector('[data-cart-discount-row]');
  const discountTotalNode = form.querySelector('[data-cart-discount-total]');
  const savedDiscountCode = window.localStorage?.getItem('thatstoreDiscountCode');
  const hasConfirmedDiscount = form.dataset.hasDiscount === 'true';

  const syncDiscountClearState = () => {
    if (!discountClearButton) return;
    discountClearButton.hidden = !(discountInput?.value.trim() || hasConfirmedDiscount);
  };

  const setDiscountUi = (cart, code = '') => {
    const discountAmount = Number(cart?.total_discount || 0);
    const hasDiscount = discountAmount > 0 || (cart?.cart_level_discount_applications || []).length > 0;

    if (subtotalNode && cart) subtotalNode.textContent = formatMoney(cart.total_price);
    if (itemsTotalNode && cart) itemsTotalNode.textContent = formatMoney(cart.original_total_price || cart.items_subtotal_price || cart.total_price);

    if (discountRow) discountRow.hidden = !hasDiscount;
    if (discountTotalNode) discountTotalNode.textContent = `-${formatMoney(discountAmount)}`;
    if (discountClearButton) discountClearButton.hidden = !hasDiscount;
    if (discountInput && code && hasDiscount) discountInput.value = code;

    return hasDiscount;
  };

  if (savedDiscountCode && hasConfirmedDiscount) {
    if (discountInput) discountInput.value = savedDiscountCode;
    if (discountClearButton) discountClearButton.hidden = false;
    if (discountMessage) discountMessage.textContent = 'Coupon applied.';
  } else if (savedDiscountCode && !hasConfirmedDiscount) {
    window.localStorage?.removeItem('thatstoreDiscountCode');
    if (discountClearButton) discountClearButton.hidden = true;
    if (discountMessage) discountMessage.textContent = 'Coupon was not applied. Check the code and try again.';
  }

  syncDiscountClearState();

  discountInput?.addEventListener('input', () => {
    syncDiscountClearState();
  });

  discountButton?.addEventListener('click', async () => {
    const code = discountInput?.value.trim();
    if (!code) {
      if (discountMessage) discountMessage.textContent = 'Enter a coupon code first.';
      discountInput?.focus();
      return;
    }

    discountButton.disabled = true;
    if (discountMessage) discountMessage.textContent = 'Checking coupon...';

    try {
      await fetch('/discount/CLEAR?redirect=/cart.js', { credentials: 'same-origin' });
      await fetch(`/discount/${encodeURIComponent(code)}?redirect=/cart.js`, {
        credentials: 'same-origin'
      });

      const cartResponse = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      const cart = await cartResponse.json();
      updateCartCount(cart.item_count);

      if (setDiscountUi(cart, code)) {
        window.localStorage?.setItem('thatstoreDiscountCode', code);
        syncDiscountClearState();
        if (discountMessage) discountMessage.textContent = 'Coupon applied.';
      } else {
        window.localStorage?.removeItem('thatstoreDiscountCode');
        await fetch('/discount/CLEAR?redirect=/cart.js', { credentials: 'same-origin' });
        syncDiscountClearState();
        if (discountMessage) discountMessage.textContent = 'Invalid coupon code.';
      }
    } catch (error) {
      if (discountMessage) discountMessage.textContent = 'Could not check coupon. Please try again.';
    } finally {
      discountButton.disabled = false;
    }
  });

  form.querySelectorAll('[data-discount-remove]').forEach((button) => {
    button.addEventListener('click', async () => {
      window.localStorage?.removeItem('thatstoreDiscountCode');
      if (discountInput) discountInput.value = '';
      button.hidden = true;
      if (discountMessage) discountMessage.textContent = 'Coupon cleared.';

      try {
        await fetch('/discount/CLEAR?redirect=/cart.js', { credentials: 'same-origin' });
        const cartResponse = await fetch('/cart.js', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });
        const cart = await cartResponse.json();
        setDiscountUi(cart);
        if (discountMessage) discountMessage.textContent = 'Coupon cleared.';
      } catch (error) {
        if (discountMessage) discountMessage.textContent = 'Coupon cleared. Refresh cart if totals do not update.';
      }
    });
  });
});

document.querySelectorAll('[data-custom-sort]').forEach((sort) => {
  const form = sort.closest('form');
  const input = form?.querySelector('[data-sort-input]');
  const label = sort.querySelector('[data-sort-label]');

  sort.querySelectorAll('[data-sort-option]').forEach((option) => {
    option.addEventListener('click', () => {
      if (input) input.value = option.dataset.value;
      if (label) label.textContent = option.textContent.trim();

      sort.querySelectorAll('[data-sort-option]').forEach((item) => {
        item.classList.toggle('is-active', item === option);
      });
      sort.removeAttribute('open');
    });
  });
});

document.addEventListener('click', (event) => {
  document.querySelectorAll('[data-custom-sort][open]').forEach((sort) => {
    if (!sort.contains(event.target)) sort.removeAttribute('open');
  });
});
